import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { EmojiSmileIconComponent } from '../../../@icons/emoji-smile-icon.component';
import { EmojiBadIconComponent } from '../../../@icons/emoji-bad-icon.component';
import { EmojiMehIconComponent } from '../../../@icons/emoji-meh-icon.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'vw-emoji-select',
    imports: [
        EmojiSmileIconComponent,
        EmojiBadIconComponent,
        EmojiMehIconComponent,
        NgClass
    ],
    templateUrl: './emoji-select.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './emoji-select.component.scss'
})
export class EmojiSelectComponent {
  @Input() selectedEmoji: 'smile' | 'meh' | 'bad' = 'smile';
  @Output() selectedEmojiChange: EventEmitter<'smile' | 'meh' | 'bad'> = new EventEmitter<'smile' | 'meh' | 'bad'>();

  onSelectEmoji(emoji: 'smile' | 'meh' | 'bad') {
    this.selectedEmoji = emoji;
    this.selectedEmojiChange.emit(this.selectedEmoji);
  }
}
